<template>
    <div id="appProject">
        <com-loading></com-loading>
        <com-progress></com-progress>
        <!--preview and edit-->
        <com-header v-if="currentStatus==='preview'"
            :links="headerLinks"
            :title="getSelectProject.projectName"></com-header>
        <div v-if="currentStatus==='preview'"
            class="main preview">
            <div class="edit">
                <div v-if="haveRecord"
                    class="editControlBtns">
                    <div title="每行拍子數">
                        <input v-model="beatPerLine"
                            type="number"
                            step=1
                            min=0>
                        <i class="fa fa-level-down"
                            aria-hidden="true"
                            @click.stop="showGenerateRecordModal()"></i>
                    </div>
                    <div title="節拍器速度">
                        <i class="fa fa-music"
                            aria-hidden="true"></i>
                        <input v-model="playSpeed"
                            type="number"
                            step=1
                            min=0
                            @change="changeSpeed">
                    </div>
                </div>
                <div class="imgDiv countDownSetting">
                    <div class="editBtns">
                        <span>倒數拍數</span>
                        <span>{{getSelectProject.countDownBeats}}</span>
                        <i class="fa fa-plus"
                            aria-hidden="true"
                            @click.stop="addCountDownBeats()"></i>
                        <i class="fa fa-minus"
                            aria-hidden="true"
                            @click.stop="minusCountDownBeats()"></i>
                    </div>
                </div>
                <div v-for="(recordImgObj, index) in recordImgs"
                    :key="index"
                    class="imgDiv">
                    <div class="editBtns">
                        <span>P{{index + 1}}</span>
                        <span>{{recordImgObj.beats}}</span>
                        <i class="fa fa-plus"
                            aria-hidden="true"
                            @click.stop="addBeat(index)"></i>
                        <i v-if="recordImgObj.beats>0"
                            class="fa fa-minus"
                            aria-hidden="true"
                            @click.stop="minusBeat(index)"></i>
                    </div>
                    <div class="controlBtns">
                        <i v-if="index!==0"
                            class="fa fa-arrow-up borderTop"
                            aria-hidden="true"
                            @click.stop="moveRecordBegin(recordImgObj.fileName)"></i>
                        <i v-if="index!==getSelectProject.record.length-1"
                            class="fa fa-arrow-down borderBottom"
                            aria-hidden="true"
                            @click.stop="moveRecordEnd(recordImgObj.fileName)"></i>
                        <i v-if="index!==0"
                            class="fa fa-arrow-up"
                            aria-hidden="true"
                            @click.stop="moveRecordUp(recordImgObj.fileName)"></i>
                        <i v-if="index!==getSelectProject.record.length-1"
                            class="fa fa-arrow-down"
                            aria-hidden="true"
                            @click.stop="moveRecordDown(recordImgObj.fileName)"></i>
                        <i class="fa fa-times deleteBtn"
                            aria-hidden="true"
                            @click.stop="showDeleteRecordModal(recordImgObj.fileName)"></i>
                    </div>
                    <img :src="recordImgObj.src">
                </div>
                <div v-if="haveRecord"
                    class="circleBtn playBtn">
                    <i class="fa fa-play"
                        aria-hidden="true"
                        @click="startPlay"></i>
                </div>
            </div>
            <div class="upload">
                <div v-if="!haveImageFile"
                    class="uploadDiv">
                    <i class="fa fa-upload"
                        aria-hidden="true"></i>
                    <span>請將樂譜檔案拖曳至此進行上傳</span>
                    <input type="file"
                        class="uploadInput"
                        multiple
                        @change="uploadFile">
                </div>
                <div class="previewImgs">
                    <div v-for="(imgObj, index) in projectImgs"
                        :key="index"
                        class="imgDiv">
                        <div class="page">
                            <span>P{{index + 1}}</span>
                        </div>
                        <div class="controlBtns">
                            <i v-if="index!==0"
                                class="fa fa-arrow-up borderTop"
                                aria-hidden="true"
                                @click.stop="moveFilBegin(imgObj.fileName)"></i>
                            <i v-if="index!==projectImgs.length-1"
                                class="fa fa-arrow-down borderBottom"
                                aria-hidden="true"
                                @click.stop="moveFileEnd(imgObj.fileName)"></i>
                            <i v-if="index!==0"
                                class="fa fa-arrow-up"
                                aria-hidden="true"
                                @click.stop="moveFileUp(imgObj.fileName)"></i>
                            <i v-if="index!==projectImgs.length-1"
                                class="fa fa-arrow-down"
                                aria-hidden="true"
                                @click.stop="moveFileDown(imgObj.fileName)"></i>
                            <i class="fa fa-times deleteBtn"
                                aria-hidden="true"
                                @click.stop="showDeleteFileModal(imgObj.fileName)"></i>
                        </div>
                        <img :src="imgObj.src"
                            @click="triggerCutter">
                    </div>
                </div>
                <button class="circleBtn uploadBtn"
                    @click="showUploadModal">
                    <i class="fa fa-plus"
                        aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <com-modal modalType="preview"
            modalId="uploadModal">
            <div slot="modalContent">
                <div class="uploadDiv">
                    <i class="fa fa-upload"
                        aria-hidden="true"></i>
                    <span>請將樂譜檔案拖曳至此進行上傳</span>
                    <input type="file"
                        class="uploadInput"
                        multiple
                        @change="uploadFile">
                </div>
            </div>
        </com-modal>
        <com-modal modalType="confirm"
            modalId="confirmDeleteModal"
            title="確認刪除該頁樂譜?"
            @confirm="deleteFile"></com-modal>
        <com-modal modalType="confirm"
            modalId="confirmDeleteRecordModal"
            title="確認刪除此筆記錄?"
            @confirm="deleteRecord"></com-modal>
        <com-modal modalType="confirm"
            modalId="confirmGenerateRecordModal"
            title="確認更新所有頁面節拍數?"
            @confirm="generateRecord"></com-modal>
        <com-modal modalTpye="alert"
            alertType="fail"
            modalId="uploadFileTypeModal"
            :title="uploadFileTypeCheckAlert"></com-modal>
        <!-- /preview and edit-->

        <!--playing-->
        <div v-if="currentStatus==='play'"
            class="play">
            <div class="progressDiv">
                <div class="progressBar">
                    <b-progress v-model="playingBeat"
                        :max="playingRecordObj.beats"
                        :precision="1"></b-progress>
                </div>
            </div>
            <div class="playingContent">
                <div class="imgDiv countDownDiv"
                    :class="{hide: 0<=playingBeat}">
                    <span v-for="(beat, index) in getSelectProject.countDownBeats"
                        :key="index"
                        class="countDownAnimate"
                        :class="{active: index<(playingBeat + getSelectProject.countDownBeats)}">
                        {{beat}}
                    </span>
                </div>
                <div v-for="(recordObj,index) in recordImgs"
                    :key="index"
                    class="imgDiv"
                    :class="{hide: index<playingPage}">
                    <img :src="recordObj.src">
                </div>
            </div>
            <div v-if="playingPage > 0"
                class="prevBtn"
                @click="prevPage()">
                <i class="fa fa-angle-double-left"
                    aria-hidden="true"></i>
            </div>
            <div v-if="playingPage < recordImgs.length - 1"
                class="nextBtn"
                @click="nextPage()">
                <i class="fa fa-angle-double-right"
                    aria-hidden="true"></i>
            </div>
            <div class="circleBtn pauseBtn">
                <i class="fa fa-pause"
                    aria-hidden="true"
                    @click.stop="pause"></i>
            </div>
            <div class="pageNum">
                {{playingPage + 1}} / {{recordImgs.length}}
            </div>
            <div v-if="playStatus==='pause'"
                class="pauseScreen">
                <div v-if="playingPage > 0"
                    class="prevBtn"
                    @click="prevPage()">
                    <i class="fa fa-angle-double-left"
                        aria-hidden="true"></i>
                </div>
                <div v-if="playingPage < recordImgs.length - 1"
                    class="nextBtn"
                    @click="nextPage()">
                    <i class="fa fa-angle-double-right"
                        aria-hidden="true"></i>
                </div>
                <div class="btnGroup">
                    <div v-if="playingBeat!==playingRecordObj.beats"
                        class="circleBtn playBtn">
                        <i class="fa fa-play"
                            aria-hidden="true"
                            @click="keepPlay"></i>
                    </div>
                    <div class="circleBtn repeatBtn">
                        <i class="fa fa-repeat"
                            aria-hidden="true"
                            @click.stop="reply"></i>
                    </div>
                    <div class="circleBtn stopBtn">
                        <i class="fa fa-stop"
                            aria-hidden="true"
                            @click.stop="stop"></i>
                    </div>
                    <div @click="toListPage"
                        class="circleBtn toListBtn">
                        <i class="fa fa-list"
                            aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
        <!--/playing-->

    </div>
</template>

<script>
import _ from 'lodash';
import Cropper from 'cropperjs';
import router from '@/router';
import { mapActions, mapGetters, mapMutations, } from 'vuex';
import { log, fullScreen, arrayElementMoveForward, arrayElementMoveBackword, arrayElementMoveBegin, arrayElementMoveEnd } from '@/js/function';
import sys from '@/js/variable';
import comHeader from '@/components/com-header.vue';
import comProgress from '@/components/com-progress.vue';

// ENTER to trigger cropper, ESC to close cropper
let that;
function keydownEvent(e) {
    log('keydown event');
    switch (e.keyCode) {
        case 13: // enter
            if (that.cropper) that.cutImg();
            break;
        case 27: // esc
            if (that.cropper) that.cropper.destroy();
            break;
        case 32: // space
            // if (this.currentStatus === 'preview') this.startPlay(); // might be trigger when edit title
            if (that.currentStatus === 'play' && that.playStatus === 'playing') that.pause();
            else if (that.currentStatus === 'play' && that.playStatus === 'pause') that.reply();
            break;
        case 37: // left arrow
            if (that.currentStatus === 'play' && that.playStatus === 'playing') that.prevPage();
            break;
        case 39: // right arrow
            if (that.currentStatus === 'play' && that.playStatus === 'playing') that.nextPage();
            break;
    }
}
// Double click to trigger cropper
function dbclickEvent(e) {
    log('dblclick event');
    if (that.cropper && e.target.classList.contains('cropper-move')) that.cutImg();
}
export default {
    components: {
        comHeader,
        comProgress,
    },
    data: () => ({
        headerLinks: ['hotkey', 'list'],
        currentStatus: 'preview',
        selectProject: {
            projectId: null,
            projectName: null,
            record: [],
            images: [],
        },
        beatPerLine: sys.defaultBeatPerline,
        playSpeed: sys.defaultSpeed,
        projectImgs: [],
        recordImgs: [],
        deleteFileName: null,
        cropper: null,
        // playing related
        playStatus: 'pause', // 'playing',
        playingPage: null,
        playingBeat: 0,
        timer: null,
        playCountCheck: null,
        uploadFileTypeCheckAlert: null,
    }),
    computed: {
        ...mapGetters(['getUser', 'getSelectProject', 'getProgress']),
        haveImageFile() {
            return this.getSelectProject && this.getSelectProject.hasOwnProperty('images') && this.getSelectProject.images.length > 0;
        },
        haveRecord() {
            return this.getSelectProject && this.getSelectProject.hasOwnProperty('record') && this.getSelectProject.record.length > 0;
        },
        playingRecordObj() {
            if (this.haveRecord) {
                if (this.playingPage >= this.getSelectProject.record.length) {
                    return this.getSelectProject.record[this.playingPage - 1];
                } else {
                    return this.getSelectProject.record[this.playingPage];
                }
            } else {
                return {
                    fileName: null,
                    Beat: null,
                }
            }
        },
    },
    watch: {
        playStatus: function(newStatus) {
            if (newStatus === 'playing') {
                const intetvalSecond = 60 / parseInt(this.playSpeed, 10) * 1000;
                this.timer = setInterval(() => {
                    this.playingBeat += 1;
                    this.checkChangePage();
                }, intetvalSecond);
            } else if (newStatus === 'pause') {
                clearInterval(this.timer);
            }
        },
        playingPage: function(newPage) {
            // count practise time
            if (newPage === 0) this.playCountCheck = 'start';
            if (this.playCountCheck === 'start') {
                const countRule = 0.9;
                const playingPagePercentage = (newPage + 1) / this.getSelectProject.record.length;
                if (playingPagePercentage > countRule) {
                    this.playCountCheck = null;
                    const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
                    newProjectObj.totalCount += 1;
                    newProjectObj.monthCount += 1;
                    this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                        this.mutationLoading(false);
                    })
                }
            }
        },
    },
    methods: {
        ...mapMutations(['mutationLoading']),
        ...mapActions(['actionGetImageUrls', 'actionUploadFile', 'actionUpdateSingleProject', 'actionGetSingleImageUrl', 'actionDeleteFile', 'actionGetProjectData', 'actionUploadFileByBase64', 'actionUploadPdfFile']),
        createImgSrc() {
            if (this.haveImageFile) {
                const promiseArray = [this.actionGetImageUrls({
                    fileArray: this.getSelectProject.images,
                })];

                if (this.haveRecord) {
                    promiseArray.push(this.actionGetImageUrls({
                        fileArray: this.getSelectProject.record.map(recordObj => recordObj.fileName),
                    }));
                }

                Promise.all(promiseArray).then((result) => {
                    if (result.length > 1) {
                        this.recordImgs = result[1].map((src, index) => {
                            return {
                                fileName: this.getSelectProject.record[index].fileName,
                                beats: this.getSelectProject.record[index].beats,
                                src,
                            }
                        });
                    }
                    this.projectImgs = result[0].map((src, index) => {
                        return {
                            fileName: this.getSelectProject.images[index],
                            src,
                        }
                    });
                    this.mutationLoading(false);
                })
            } else {
                this.mutationLoading(false);
            }
        },
        // preview mode
        showUploadModal() {
            this.$root.$emit('show::modal', 'uploadModal');
        },
        uploadFile(e) {
            ga('send', 'event', 'uploadFile', this.getUser.email);
            const inputFiles = e.target.files || e.dataTransfer.files;
            if (inputFiles.length) {
                const files = Array.from(inputFiles);
                // STEP0: upload file type & size check
                const fileType = files.reduce((typeObj, file) => {
                    const ext = file.type.replace(/.*\//, '').toLowerCase();
                    if (['jpg', 'jpeg', 'png'].indexOf(ext) > -1) typeObj.image += 1;
                    else if (['pdf'].indexOf(ext) > -1) typeObj.pdf += 1;
                    else typeObj.noSupport += 1;
                    const fileSize = file.size;
                    log('size', fileSize);
                    if (fileSize > sys.uploadFileMaxByte) typeObj.overUploadLimit = true;
                    return typeObj;
                }, {
                        image: 0,
                        pdf: 0,
                        noSupport: 0,
                        overUploadLimit: false,
                    });
                log('uploadFileCheck', fileType);

                if (fileType.noSupport) {
                    this.uploadFileTypeCheckAlert = '請使用 PNG、JPG 或 PDF 檔上傳'
                    this.$root.$emit('hide::modal', 'uploadModal');
                    this.$root.$emit('show::modal', 'uploadFileTypeModal');
                } else if (fileType.overUploadLimit) {
                    this.uploadFileTypeCheckAlert = `上傳檔案請勿超過 ${sys.uploadFileMaxByte / 1000 / 1000}MB`;
                    this.$root.$emit('hide::modal', 'uploadModal');
                    this.$root.$emit('show::modal', 'uploadFileTypeModal');
                } else {
                    // STEP1: upload file, return image array, pdf will be transfer to images
                    let promiseArray = [];
                    files.forEach((file, index) => {
                        const ext = file.type.replace(/.*\//, '').toLowerCase();
                        if (ext === 'pdf') {
                            promiseArray.push(
                                this.actionUploadPdfFile({
                                    file,
                                    index,
                                }));

                        } else {
                            promiseArray.push(
                                this.actionUploadFile({
                                    file,
                                    index,
                                }));
                        }
                    })
                    Promise.all(promiseArray).then((fileArray) => {
                        log('fileArray', fileArray);
                        // STEP2: base on return image array to update project data and get urls
                        this.mutationLoading(true);
                        const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
                        const imageArray = (newProjectObj.hasOwnProperty('images')) ? newProjectObj.images : [];
                        newProjectObj.images = fileArray.reduce((merge, images) => {
                            merge = merge.concat(images);
                            return merge;
                        }, imageArray);
                        promiseArray = [
                            this.actionUpdateSingleProject({ newProjectObj }),
                            this.actionGetImageUrls({
                                fileArray: newProjectObj.images,
                            })
                        ];
                        Promise.all(promiseArray).then((result) => {
                            const srcArray = result[1];
                            this.projectImgs = srcArray.map((src, index) => {
                                return {
                                    fileName: this.getSelectProject.images[index],
                                    src,
                                }
                            });
                            document.querySelector('.uploadInput').value = '';
                            this.$root.$emit('hide::modal', 'uploadModal');
                            this.mutationLoading(false);
                        })
                    })
                }
            };
        },
        moveFileUp(fileName) {
            ga('send', 'event', 'moveFileUp', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.images = arrayElementMoveBackword(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.projectImgs, function(obj) { return obj.fileName === fileName; });
                this.projectImgs = arrayElementMoveBackword(this.projectImgs, index);
                this.mutationLoading(false);
            })
        },
        moveFileDown(fileName) {
            ga('send', 'event', 'moveFileDown', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.images = arrayElementMoveForward(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.projectImgs, function(obj) { return obj.fileName === fileName; });
                this.projectImgs = arrayElementMoveForward(this.projectImgs, index);
                this.mutationLoading(false);
            })
        },
        moveFilBegin(fileName) {
            ga('send', 'event', 'moveFilBegin', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.images = arrayElementMoveBegin(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.projectImgs, function(obj) { return obj.fileName === fileName; });
                this.projectImgs = arrayElementMoveBegin(this.projectImgs, index);
                this.mutationLoading(false);
            })
        },
        moveFileEnd(fileName) {
            ga('send', 'event', 'moveFileEnd', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.images = arrayElementMoveEnd(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.projectImgs, function(obj) { return obj.fileName === fileName; });
                this.projectImgs = arrayElementMoveEnd(this.projectImgs, index);
                this.mutationLoading(false);
            })
        },
        showDeleteFileModal(fileName) {
            this.deleteFileName = fileName;
            this.$root.$emit('show::modal', 'confirmDeleteModal');
        },
        deleteFile() {
            ga('send', 'event', 'deleteFile', this.getUser.email);
            this.mutationLoading(true);
            this.actionDeleteFile({
                projectId: this.getSelectProject.projectId,
                file: this.deleteFileName,
            }).then(() => {
                const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
                newProjectObj.images = newProjectObj.images.filter(fileName => fileName !== this.deleteFileName);
                this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                    this.projectImgs = this.projectImgs.filter(imgObj => imgObj.fileName !== this.deleteFileName);
                    this.deleteFileName = null;
                    this.mutationLoading(false);
                })
            })
        },
        triggerCutter(e) {
            if (this.cropper) this.cropper.destroy();
            const targetImg = e.path[0];
            this.cropper = new Cropper(targetImg, {
                autoCropArea: 0.3,
                // autoCrop: false,
                zoomable: false,
                zoomOnWheel: false,
                zoomOnTouch: false,
                rotatable: false,
                ready() { },
                cropmove() { },
            });
        },
        cutImg() {
            log('issue cutter');
            function getRoundedCanvas(sourceCanvas) {
                const canvas = document.createElement('canvas');
                canvas.width = sourceCanvas.width;
                canvas.height = sourceCanvas.height;

                const context = canvas.getContext('2d');
                context.imageSmoothingEnabled = true;
                context.drawImage(sourceCanvas, 0, 0, sourceCanvas.width, sourceCanvas.height);
                return canvas;
            }

            this.mutationLoading(true);
            const croppedCanvas = this.cropper.getCroppedCanvas();
            const promiseArray = [];
            const fileName = `cut_${Date.now()}.png`;
            promiseArray.push(this.actionUploadFileByBase64({
                fileName,
                base64: getRoundedCanvas(croppedCanvas).toDataURL().substr(22),
                index: 0,
            }));

            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            log('newProjectObj', newProjectObj);
            if (newProjectObj.hasOwnProperty('record')) {
                newProjectObj.record.push({
                    fileName,
                    beats: 0,
                })
            } else {
                newProjectObj.record = [{
                    fileName,
                    beats: 0,
                }];
            }
            promiseArray.push(this.actionUpdateSingleProject({ newProjectObj }));
            Promise.all(promiseArray).then(() => {
                this.actionGetImageUrls({
                    fileArray: newProjectObj.record.map(recordObj => recordObj.fileName),
                }).then((srcArray) => {
                    this.recordImgs = srcArray.map((src, index) => {
                        return {
                            fileName: this.getSelectProject.record[index].fileName,
                            beats: this.getSelectProject.record[index].beats,
                            src,
                        }
                    });
                    this.mutationLoading(false);
                })
            })
        },
        showDeleteRecordModal(fileName) {
            this.deleteFileName = fileName;
            this.$root.$emit('show::modal', 'confirmDeleteRecordModal');
        },
        deleteRecord() {
            ga('send', 'event', 'deleteRecord', this.getUser.email);
            this.mutationLoading(true);
            this.actionDeleteFile({
                projectId: this.getSelectProject.projectId,
                file: this.deleteFileName,
            }).then(() => {
                const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
                newProjectObj.record = newProjectObj.record.filter(obj => obj.fileName !== this.deleteFileName);
                this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                    this.recordImgs = this.recordImgs.filter(obj => obj.fileName !== this.deleteFileName);
                    this.deleteFileName = null;
                    this.mutationLoading(false);
                })
            }).catch(() => {
                // if image not exist, then keep delete record, otherwise keep record data
                const recordObj = this.recordImgs.filter(obj => obj.fileName === this.deleteFileName);
                if (recordObj.length === 1 && !recordObj[0].src) {
                    const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
                    newProjectObj.record = newProjectObj.record.filter(obj => obj.fileName !== this.deleteFileName);
                    this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                        this.recordImgs = this.recordImgs.filter(obj => obj.fileName !== this.deleteFileName);
                        this.deleteFileName = null;
                        this.mutationLoading(false);
                    })
                } else {
                    this.mutationLoading(false);
                }
            })
        },
        moveRecordUp(fileName) {
            ga('send', 'event', 'moveRecordUp', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record = arrayElementMoveBackword(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.recordImgs, function(obj) { return obj.fileName === fileName; });
                this.recordImgs = arrayElementMoveBackword(this.recordImgs, index);
                this.mutationLoading(false);
            })
        },
        moveRecordDown(fileName) {
            ga('send', 'event', 'moveRecordDown', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record = arrayElementMoveForward(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.recordImgs, function(obj) { return obj.fileName === fileName; });
                this.recordImgs = arrayElementMoveForward(this.recordImgs, index);
                this.mutationLoading(false);
            })
        },
        moveRecordBegin(fileName) {
            ga('send', 'event', 'moveRecordBegin', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record = arrayElementMoveBegin(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            log(newProjectObj.record);
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.recordImgs, function(obj) { return obj.fileName === fileName; });
                this.recordImgs = arrayElementMoveBegin(this.recordImgs, index);
                this.mutationLoading(false);
            })
        },
        moveRecordEnd(fileName) {
            ga('send', 'event', 'moveRecordEnd', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record = arrayElementMoveEnd(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            log(newProjectObj.record);
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                const index = _.findIndex(this.recordImgs, function(obj) { return obj.fileName === fileName; });
                this.recordImgs = arrayElementMoveEnd(this.recordImgs, index);
                this.mutationLoading(false);
            })
        },
        addBeat(index) {
            ga('send', 'event', 'addBeat', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record[index].beats = parseFloat(newProjectObj.record[index].beats) + 1;
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.recordImgs[index].beats = parseFloat(this.recordImgs[index].beats) + 1;
                this.mutationLoading(false);
            })
        },
        minusBeat(index) {
            ga('send', 'event', 'minusBeat', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record[index].beats = parseFloat(newProjectObj.record[index].beats) - 1;
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.recordImgs[index].beats = parseFloat(this.recordImgs[index].beats) - 1;
                this.mutationLoading(false);
            })
        },
        addCountDownBeats() {
            ga('send', 'event', 'addCountDownBeats', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.countDownBeats += 1;
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.mutationLoading(false);
            })
        },
        minusCountDownBeats() {
            ga('send', 'event', 'minusCountDownBeats', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.countDownBeats = Math.max(0, newProjectObj.countDownBeats - 1);
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.mutationLoading(false);
            })
        },
        changeSpeed() {
            ga('send', 'event', 'changeSpeed', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.speed = parseInt(this.playSpeed, 10);
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.mutationLoading(false);
            })
        },
        showGenerateRecordModal() {
            this.$root.$emit('show::modal', 'confirmGenerateRecordModal');
        },
        generateRecord() {
            ga('send', 'event', 'generateRecord', this.getUser.email);
            this.mutationLoading(true);
            const newProjectObj = JSON.parse(JSON.stringify(this.getSelectProject));
            newProjectObj.record = newProjectObj.record.map((recordObj) => {
                recordObj.beats = parseFloat(this.beatPerLine);
                return recordObj
            })
            this.actionUpdateSingleProject({ newProjectObj }).then(() => {
                this.recordImgs = this.recordImgs.map((recordObj) => {
                    recordObj.beats = parseFloat(this.beatPerLine);
                    return recordObj
                })
                this.mutationLoading(false);
            })
        },
        //playing mode
        startPlay() {
            ga('send', 'event', 'startPlay', this.getUser.email);
            fullScreen();
            this.currentStatus = 'play';
            this.playStatus = 'playing';
            this.playingPage = 0;
            this.playingBeat = this.getSelectProject.countDownBeats * -1;
        },
        keepPlay() {
            ga('send', 'event', 'keepPlay', this.getUser.email);
            this.playStatus = 'playing';
        },
        pause() {
            ga('send', 'event', 'pause', this.getUser.email);
            this.playStatus = 'pause';
        },
        reply() {
            ga('send', 'event', 'reply', this.getUser.email);
            this.playingBeat = this.getSelectProject.countDownBeats * -1;
            this.startPlay();
        },
        stop() {
            ga('send', 'event', 'stop', this.getUser.email);
            this.currentStatus = 'preview';
        },
        toListPage() {
            ga('send', 'event', 'toListPage', this.getUser.email);
            router.push({
                name: 'list',
            });
        },
        prevPage() {
            ga('send', 'event', 'prevPage', this.getUser.email);
            if (this.playingBeat <= 1) this.playingPage -= 1;
            this.playingBeat = 0;
        },
        nextPage() {
            ga('send', 'event', 'nextPage', this.getUser.email);
            this.playingPage += 1;
            this.playingBeat = 0;
        },
        checkChangePage() {
            if (this.playingBeat === this.playingRecordObj.beats) {
                this.playingPage += 1;
                if (this.playingPage < this.getSelectProject.record.length) this.playingBeat = 0;
                else this.pause();
            }
        },
    },
    beforeCreate() { },
    created() {
        log(this.$route.params.id);
        this.mutationLoading(true);
        if (!this.getSelectProject || this.$route.params.id !== this.getSelectProject.projectId) {
            // query project data if current select project in vuex not match the url hash
            this.actionGetProjectData({
                projectId: this.$route.params.id,
            }).then(() => {
                // get image url
                this.createImgSrc();
                // update speed and beat base project setting
                this.playSpeed = this.getSelectProject.speed;
                if (this.getSelectProject.hasOwnProperty('record')) {
                    const countBeat = this.getSelectProject.record.reduce((summary, recordObj) => {
                        if (summary.hasOwnProperty(recordObj.beats)) {
                            summary[recordObj.beats] += 1;
                        } else {
                            summary[recordObj.beats] = 1;
                        }
                        if (summary[recordObj.beats] > summary.used) {
                            summary.used = summary[recordObj.beats];
                            summary.maxBeat = recordObj.beats;
                        }
                        return summary;
                    }, {
                            maxBeat: null,
                            used: 0,
                        });
                    this.beatPerLine = countBeat.maxBeat;
                }
            });
        } else {
            this.createImgSrc();
            // update speed and beat base project setting
            this.playSpeed = this.getSelectProject.speed;
            if (this.getSelectProject.hasOwnProperty('record')) {
                const countBeat = this.getSelectProject.record.reduce((summary, recordObj) => {
                    if (summary.hasOwnProperty(recordObj.beats)) {
                        summary[recordObj.beats] += 1;
                    } else {
                        summary[recordObj.beats] = 1;
                    }
                    if (summary[recordObj.beats] > summary.used) {
                        summary.used = summary[recordObj.beats];
                        summary.maxBeat = recordObj.beats;
                    }
                    return summary;
                }, {
                        maxBeat: null,
                        used: 0,
                    });
                this.beatPerLine = countBeat.maxBeat;
            }
        }
    },
    beforeMount() { },
    mounted() {
        that = this;
        document.addEventListener('keydown', keydownEvent);
        document.querySelector('.previewImgs').addEventListener('dblclick', dbclickEvent)
    },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() {
        document.removeEventListener('keydown', keydownEvent);
        document.querySelector('.previewImgs').removeEventListener('dblclick', dbclickEvent);
    },
    destroyed() { },
}

</script>

<style lang="scss">
@import '../style/variable.scss';
#appProject {
    .preview {
        display: flex;
        height: calc(100vh - #{$headerHeight});
        overflow-y: hidden;
        .imgDiv {
            position: relative;
            margin: 30px 0;
            .controlBtns {
                position: absolute;
                right: 0;
                top: -25px;
                i {
                    font-size: 0.9rem;
                    cursor: pointer;
                    margin-left: 3px;
                    &:hover {
                        color: rgba(50, 50, 50, .8);
                    }
                }
                .borderTop {
                    border-top: 2px solid #292b2c;
                }
                .borderBottom {
                    border-bottom: 2px solid #292b2c;
                }
            }
            img {
                width: 100%;
                max-width: 100%;
            }
            &.countDownSetting {
                height: 10px;
            }
        }
        .edit {
            flex: 1;
            min-width: 360px;
            height: 100%;
            overflow-y: auto;
            padding: 0 1px;
            border: 1px solid rgba(100, 100, 100, .5);
            background: rgba(250, 250, 250, .15);
            img {
                width: 100%;
                max-height: 200px;
            }
            .editBtns {
                position: absolute;
                left: 0;
                top: -31px;
                font-size: 1.4rem;
                span {
                    background: rgba(0, 0, 0, .5);
                    color: white;
                    padding: 0 5px;
                    text-align: center;
                }
                i {
                    cursor: pointer;
                    &:hover {
                        color: rgba(50, 50, 50, .8);
                    }
                }
            }
            .editControlBtns {
                font-size: 1.3rem;
                display: flex;
                justify-content: space-between;
                input {
                    text-align: center;
                    width: 60px;
                }
                i {
                    margin: 0 2px;
                    cursor: pointer;
                    &:hover {
                        color: rgba(50, 50, 50, .8);
                    }
                }
            }
        }
        .upload {
            flex: 2;
            height: 100%;
            border: 1px solid rgba(100, 100, 100, .5);
            background: rgba(250, 250, 250, .3);
            .previewImgs {
                width: 100%;
                height: 100%;
                overflow-y: auto;
                padding: 2px;
            }
            .imgDiv {
                .page {
                    position: absolute;
                    left: 0;
                    top: -22px;
                    span {
                        background: rgba(0, 0, 0, .5);
                        color: white;
                        padding: 0 5px;
                        text-align: center;
                    }
                }
                .controlBtns {
                    top: -25px;
                    i {
                        font-size: 1.3rem;
                        &:hover {
                            color: rgba(50, 50, 50, .8);
                        }
                    }
                }
                img {
                    cursor: pointer;
                    &:hover {
                        filter: opacity(0.8);
                    }
                }
            }
        }
        .uploadBtn {
            position: absolute;
            bottom: 5px;
            right: 5px;
        }
        .playBtn {
            position: absolute;
            bottom: 5px;
            left: 5px;
        }
    }
    .uploadDiv {
        @include verticalCenter;
        flex-direction: column;
        height: 500px;
        font-size: 2rem;
        margin: 10px;
        border: dotted 2px darkgray;
        position: relative;
        .uploadInput {
            cursor: pointer;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            color: transparent;
            background-color: transparent;
            opacity: 0;
        }
    }
    .play {
        flex-direction: row;
        position: relative;
        .progressDiv {
            height: $progressHeight;
            display: flex; // justify-content: space-between;
            span {
                width: 80px;
                text-align: center;
            }
            .progressBar {
                width: 100vw;
                .progress {
                    height: calc(#{$progressHeight} - 4px);
                    margin: 2px 0;
                    .progress-bar {
                        height: 100%;
                        background: linear-gradient(-90deg, rgba(50, 50, 50, .9), rgba(0, 0, 0, 0.5));
                    }
                }
            }
        }
        .playingContent {
            flex: 1;
            text-align: center;
            height: calc(100vh - #{$progressHeight});
            .imgDiv {
                width: 100%;
                height: calc((100vh - #{$progressHeight})/ 3);
                transition: all 1s ease;
                img {
                    height: 100%;
                    max-width: 100%;
                }
                &.hide {
                    height: 0; // width: 0;
                    .countDownAnimate {
                        color: transparent;
                    }
                }
            }
            .imgDiv:nth-last-child(-n+3) {
                &.hide {
                    height: calc((100vh - #{$progressHeight})/ 3);
                    img {
                        filter: opacity(0.5);
                    }
                }
            }
        }
        .prevBtn,
        .nextBtn {
            position: absolute;
            z-index: 0;
            top: 0;
            width: 50%;
            height: 100%;
            font-size: 3rem;
            &:hover {
                background: rgba(100, 100, 100, 0.1);
            }
            i {
                position: absolute;
                top: calc(50% - 24px);
                cursor: pointer;
            }
        }
        .prevBtn {
            cursor: pointer;
            left: 0;
            i {
                left: 10px;
            }
        }
        .nextBtn {
            cursor: pointer;
            right: 0;
            i {
                right: 10px;
            }
        }
        .pageNum {
            position: absolute;
            left: 5px;
            bottom: 5px;
            font-size: 1.2rem;
            color: white;
        }
        .pauseBtn {
            position: absolute;
            bottom: 5px;
            right: 5px;
        }
        .pauseScreen {
            @include fullScreenCenter;
            justify-content: flex-end;
            background: transparentize($halfTransparentBg, 0.5);
            height: 100vh;
            flex-direction: column;
            z-index: 9;
            .btnGroup {
                z-index: 9;
                display: flex;
                flex-direction: row;
                .circleBtn {
                    margin: 10px;
                }
            }
        }
        .countDownDiv {
            display: flex;
            justify-content: center;
            align-items: center;
            .countDownAnimate {
                font-size: 3rem;
                color: lightgray;
                margin: 10px;
                &.active {
                    color: white;
                    font-size: 4rem;
                    font-weight: 800;
                    transition: all 0.5s ease;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// app-project.vue?12feba7e